import React from "react";
import { MDBRow, MDBCol, MDBIcon } from "mdbreact";

import PropTypes from "prop-types";
import { ConvertInstitutoToArea } from "../../helpers/Formatters";
import { GGgetMode } from "../../services/gglocalstorage";
import Carousel from "react-multi-carousel";
import CardCurso from "../CardCurso/CardCurso";

export default function CarouselCursos({ cursos, instituto }) {
	CarouselCursos.propTypes = {
		instituto: PropTypes.string.isRequired,
		cursos: PropTypes.array.string,
	};

	const responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1025 },
			items: 3,
			slidesToSlide: 3, // optional, default to 1.
		},
		tablet: {
			breakpoint: { max: 1024, min: 465 },
			items: 2,
			slidesToSlide: 2, // optional, default to 1.
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
	};

	// Define os botões de avanço e retorno do carousel.
	// No mobile as setas ficam ocultas e a navegação acontece por swipe.
	const ButtonGroup = ({ next, previous }) => {
		return (
			<>
				<MDBIcon
					className={
						(GGgetMode() ? "text-secondary" : "text-primary") +
						" d-none d-md-block"
					}
					style={{
						position: "absolute",
						zIndex: 1000,
						top: "40%",
						left: "-4%",
						backgroundColor: "transparent",
						cursor: "pointer",
					}}
					icon="chevron-left"
					size="3x"
					onClick={() => previous()}
				/>

				<MDBIcon
					className={
						(GGgetMode() ? "text-secondary" : "text-primary") +
						" d-none d-md-block"
					}
					style={{
						position: "absolute",
						zIndex: 1000,
						top: "40%",
						right: "-4%",
						backgroundColor: "transparent",
						cursor: "pointer",
					}}
					icon="chevron-right"
					size="3x"
					onClick={() => next()}
				/>
			</>
		);
	};

	return (
		<MDBRow>
			<MDBCol>
				<MDBRow>
					<MDBCol>
						<h3 className="text-primary py-2 text-center text-md-left saira-title">
							{instituto ? (
								<>
									Mais cursos da área de{" "}
									<span className="font-weight-bold">{instituto}</span>
								</>
							) : (
								<>
									Conheça os cursos da{" "}
									<span className="font-weight-bold">Feevale</span>
								</>
							)}
						</h3>
					</MDBCol>
				</MDBRow>
				<MDBRow>
					<MDBCol>
						<Carousel
							swipeable={true}
							draggable={false}
							showDots={false}
							responsive={responsive}
							ssr={true} // means to render carousel on server-side.
							infinite={true}
							autoPlay={true}
							autoPlaySpeed={3000}
							keyBoardControl={true}
							transitionDuration={500}
							arrows={false}
							renderButtonGroupOutside={true}
							customButtonGroup={<ButtonGroup />}
							containerClass="carousel-container"
						>
							{cursos.map(
								(element) =>
									(!instituto ||
										ConvertInstitutoToArea(element.Instituto) ===
											instituto) && (
										<CardCurso
											className="mx-1 mx-md-2"
											key={element.Title}
											slug={element.Slug}
											instituto={ConvertInstitutoToArea(element.Instituto)}
											opcoes={element.Opcoes}
											name={element.Title}
										/>
									)
							)}
						</Carousel>
					</MDBCol>
				</MDBRow>
			</MDBCol>
		</MDBRow>
	);
}
